import React, { useState } from 'react';
import { changePassword } from '../../services/userApiService';
import { motion } from 'framer-motion';
import { FaCheckCircle, FaExclamationCircle } from 'react-icons/fa';
import FloatingLabelInput from '../ui/FloatingLabelInput';

const ChangePassword = () => {
  const [formValues, setFormValues] = useState({
    userId:localStorage.getItem('userID'),
    currentPassword: '',
    newPassword: '',
    confirmPassword: '',
});
const [apiResponse, setApiResponse] = useState(null);
const [loading, setLoading] = useState(false);

  const [errors, setErrors] = useState({});

  const inputClasses = (field) =>
    errors[field] ? 'border-red-500' : 'border-gray-300';

    // Simple validation function
    const validate = () => {
        const newErrors = {};
        if (!formValues.userId) newErrors.userId = 'Please try again Later';
        if (!formValues.currentPassword) newErrors.currentPassword = 'Current Password is required';
        if (!formValues.newPassword) newErrors.newPassword = 'Password is required';
        if (!formValues.confirmPassword) newErrors.confirmPassword = 'Confirm Password is required';
        if (!(formValues.newPassword === formValues.confirmPassword)) newErrors.confirmPassword = 'password & Confirm password Mismatch';
        if ((formValues.userId === 'undefined')) newErrors.userId = 'Session Out. Please login again';

        return newErrors;
    };

    const handleBlur = (field) => {
        const validationErrors = validate();
        setErrors(validationErrors);
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormValues({ ...formValues, [name]: value });
        setErrors({ ...errors, [name]: '' }); // Clear error when user types

    };

  
    const handleSubmit = async (e) => {

      e.preventDefault();
      const validationErrors = validate();
      // const isValid = await handleValidation(formValues);
      // if (!isValid) return; 
      if (Object.keys(validationErrors).length === 0) {
      try {
          // await validationSchema.validate(formValues, { abortEarly: false });
       
          // setErrors({});
      setLoading(true);
          let data;
              data = await changePassword(formValues);
          
          setApiResponse(data);
          if(!data.error){
          resetFormValues();
          }else{
              return;
          }
      } catch (err) {
          const validationErrors = {};
          err.inner.forEach(error => {
              validationErrors[error.path] = error.message;
          });
          setErrors(validationErrors);
          setApiResponse({ err: 'Failed to submit form. Please try again.' });
      } finally {
          setLoading(false);
      }
      setErrors({});
  } else {
      setErrors(validationErrors);
  }
  };
  const resetFormValues = ()=> {
      setFormValues({
        currentPassword: '',
        newPassword: '',
        confirmPassword: '',
      }); 
      setErrors({});
      //setApiResponse(null);
  }

  const handleCancel = () => {
      resetFormValues();
      // navigate('/clientRegistration'); // Replace with your desired URL
      // window.location.reload();
  };

  return (
    // <div className="flex items-center justify-center min-h-screen bg-gray-100">
    <div>
      <div className="w-full max-w-md p-6 bg-white rounded-lg shadow-md">
        <h2 className="mb-6 text-2xl font-semibold text-center text-gray-700">Change Password</h2>
        <form   onSubmit={handleSubmit}>
          <div className="mb-4">
            <input
                                        type="hidden"
                                        name="userId"
                                        value={formValues.userId}
                                        id="userId"
                                        autoComplete="off"
                                        readOnly={true}
                                        onChange={handleChange}
                                    />
           <FloatingLabelInput
                                        type='password'
                                        label="Current Password"
                                        id="currentPassword"
                                        name="currentPassword"
                                        value={formValues.currentPassword}
                                        onChange={handleChange}
                            onBlur={() => handleBlur('currentPassword')}
                            className={inputClasses('currentPassword')}

                                    />
                                    {errors.currentPassword && <div className="text-red-500 text-sm">{errors.currentPassword}</div>}
          </div>
          <div className="mb-4">
            <FloatingLabelInput
                                        type='password'
                                        label="New Password"
                                        id="newPassword"
                                        name="newPassword"
                                        value={formValues.newPassword}
                                        onChange={handleChange}
                            onBlur={() => handleBlur('newPassword')}
                            className={inputClasses('newPassword')}

                                    />
                                    {errors.newPassword && <div className="text-red-500 text-sm">{errors.newPassword}</div>}
          </div>
          <div className="mb-4">
            <FloatingLabelInput
                                        type='password'
                                        label="Confirm Password"
                                        id="confirmPassword"
                                        name="confirmPassword"
                                        value={formValues.confirmPassword}
                                        onChange={handleChange}
                            onBlur={() => handleBlur('confirmPassword')}
                            className={inputClasses('confirmPassword')}

                                    />
                                    {errors.confirmPassword && <div className="text-red-500 text-sm">{errors.confirmPassword}</div>}
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="mt-4">
                                <button
                                    type="submit"
                                    className={`px-4 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600 ${loading  ? 'opacity-50' : ''}`}
                                    disabled={loading }
                                >
                                    {loading  ? 'Submitting...' :  'Change Password'}
                                </button>
                            </div>
                            <div className="mt-4">
                                <button
                                    type="button"
                                    onClick={handleCancel } // This is how you reset the form
                                    className="px-4 py-2 bg-gray-500 text-white rounded-md hover:bg-gray-600"
                                >
                                    Cancel
                                </button>
                            </div>
                            </div>
        </form>
        {apiResponse && (
                    <motion.div
                        className={`mt-4 flex items-center ${apiResponse.error ? 'text-red-500' : 'text-green-500'}`}
                        initial={{ opacity: 0, y: 20 }}
                        animate={{ opacity: 1, y: 0 }}
                        transition={{ duration: 0.5 }}
                    >
                        {apiResponse.error ? (
                            <>
                                <FaExclamationCircle className="mr-2" />
                                {apiResponse.error}
                            </>
                        ) : (
                            <>
                                <FaCheckCircle className="mr-2" />
                                {apiResponse.success}
                            </>
                        )}
                    </motion.div>
                )}
      </div>
    </div>
  );
};




const TestPage = () => {
    return (<div  className="container mx-auto p-6">
            {/* <MenuPermission data={data} clientData={clients} /> */}
            <ChangePassword  />
            </div>)
};

export default TestPage;
